import React, { useEffect, useState } from "react"
import { Card, Col, Row, Button, Spin, Pagination } from "antd"
import OrderB2BService from "src/services/OrderB2BService"
import CheckPackage from "./components/CheckPackage"
import { addToCart } from "src/redux/cartSlice"
import { useDispatch } from "react-redux"
import { ShoppingCartOutlined } from "@ant-design/icons"
import STORAGE, { getStorage } from "src/lib/storage"
import "./index.css"

const BuyPackageAnonymous = ({ setOpenCart }) => {
  const [selectedOptions, setSelectedOptions] = useState({})
  const [loading, setLoading] = useState(false)
  const [listPackage, setListPackage] = useState([])
  const [filter, setFilter] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(6)
  const [total, setTotal] = useState(0)
  const level = localStorage.getItem(STORAGE.LEVEL)

  const dispatch = useDispatch()

  const sortedNumbers = arr => {
    if (!Boolean(arr.length)) {
      return []
    }
    return arr.map(Number).sort((a, b) => a - b)
  }

  const fetchPackages = async () => {
    setLoading(true)
    try {
      const response = await OrderB2BService.getBoughtPackage({
        filter,
        page: currentPage,
        per_page: pageSize,
      })
      const rawData = response.success?.data || {}
      setTotal(response.success?.total)

      const transformed = Object.entries(rawData).map(
        ([carrierName, carrierData]) => {
          let allDays = new Set()
          let allData = new Set()
          let prices = {}
          let notes = {}
          let priceList = []
          let supplier = new Set()
          let packageIds = []
          let packageMap = {}
          let carrier_id = new Set()
          let simTypeList = []
          let typeSimList = []
          let scopeList = []
          let packageTypeList = []
          let modeList = []
          let listsDiscount = []
          let listsGeneralPrice = []

          // Duyệt qua các gói cước của từng nhà mạng
          Object.entries(carrierData).forEach(([simType, packages]) => {
            packages.forEach(pkg => {
              if (pkg.supplier_id) supplier.add(pkg.supplier_id)
              if (pkg.ID) packageIds.push(pkg.ID)
              if (pkg.network_carrier_id) carrier_id.add(pkg.network_carrier_id)
              if (pkg.sim_type) simTypeList.push(pkg.sim_type)
              if (pkg.type_sim) typeSimList.push(pkg.type_sim)
              if (pkg.service_type) scopeList.push(pkg.service_type)
              if (pkg.package_type) packageTypeList.push(pkg.package_type)
              if (pkg.mode) modeList.push(pkg.mode)
              if (pkg.commission) listsDiscount.push(pkg.commission)
              if (pkg.master_price && level != 0 ? pkg.master_price : pkg.price_setting)
                listsGeneralPrice.push(pkg.master_price && level != 0 ? pkg.master_price : pkg.price_setting)
              const daysMatch = pkg.date.match(/(\d+)/)
              const dataMatch = pkg.data_quantity
              const typeSimMatch = pkg.type_sim
              const simTypeMatch = pkg.sim_type
              const scopeMatch = pkg.service_type

              if (
                daysMatch &&
                dataMatch &&
                scopeMatch &&
                typeSimMatch &&
                simTypeMatch
              ) {
                const days = parseInt(daysMatch[1])
                const size = dataMatch
                const simType = simTypeMatch
                const typeSim = typeSimMatch
                const scope = scopeMatch

                const key = `${days}-${size}-${typeSim}-${simType}-${scope}`
                allDays.add(days)
                allData.add(size)

                const price =
                  level === "0"
                    ? Number(pkg.price_sell)
                    : Number(pkg.price_setting) ? Number(pkg.price_setting) : Number(pkg.master_price) ? Number(pkg.master_price) : Number(pkg.price_sell) 
                prices[key] = price
                priceList.push(price)
                const note = pkg.note
                notes[key] = note

                // Thêm gói cước vào map
                if (!packageMap[key]) {
                  packageMap[key] = []
                }

                // packageMap[key].push(pkg.ID)
                packageMap[key].push({
                  id: pkg.ID,
                  note: pkg.note,
                  package_type: pkg.package_type,
                  mode: pkg.mode,
                  commission: pkg.commission,
                  master_price: level != 0 ? pkg.master_price : null,
                })
              }
            })
          })

          let priceRange = "N/A"
          if (priceList.length > 0) {
            const min = Math.min(...priceList)
            const max = Math.max(...priceList)
            if (min === max) priceRange = `${min.toLocaleString()}`
            else {
              priceRange = `${min.toLocaleString()} VNĐ - ${max.toLocaleString()}`
            }
          }

          return {
            carrier: carrierName,
            supplier: Array.from(supplier)[0],
            packageIds,
            carrier_id: Array.from(carrier_id)[0],
            priceRange,
            daysOptions: Array.from(allDays).sort((a, b) => a - b),
            dataOptions: Array.from(allData),
            prices,
            notes,
            packageMap,
            simTypeList: Array.from(new Set(simTypeList)),
            typeSimList: Array.from(new Set(typeSimList)),
            scopeList: Array.from(new Set(scopeList)),
            packageTypeList: Array.from(new Set(packageTypeList)), // ✅ thêm
            modeList: Array.from(new Set(modeList)),
            listsGeneralPrice: sortedNumbers(listsGeneralPrice),
            listsDiscount,
          }
        },
      )

      setListPackage(transformed)
    } catch (error) {
      console.error("Error fetching packages:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPackages()
  }, [filter, currentPage, pageSize])

  useEffect(() => {
    listPackage.forEach(pkg => {
      const selected = selectedOptions[pkg.carrier] || {}

      // ✅ chỉ chạy khi đã chọn ngày
      if (selected.days) {
        // ---- Dung lượng ----
        const validDataOptions = pkg.dataOptions.filter(opt => {
          const key = `${selected.days}-${opt}`
          return Object.keys(pkg.prices).some(k => k.startsWith(key))
        })
        if (validDataOptions.length === 1 && !selected.amount) {
          handleSelect(
            pkg.carrier,
            pkg.carrier_id,
            "amount",
            validDataOptions[0],
          )
        }

        // ---- Loại SIM ----
        const validTypeSim = pkg.typeSimList.filter(type => {
          const key = `${selected.days}-${selected.amount || ""}-${type}`
          return Object.keys(pkg.prices).some(k => k.startsWith(key))
        })
        if (validTypeSim.length === 1 && !selected.typeSim) {
          handleSelect(pkg.carrier, pkg.carrier_id, "typeSim", validTypeSim[0])
        }

        // ---- Loại hình SIM ----
        const validSimType = pkg.simTypeList.filter(type => {
          const key = `${selected.days}-${selected.amount || ""}-${
            selected.typeSim || ""
          }-${type}`
          return Object.keys(pkg.prices).some(k => k.startsWith(key))
        })
        if (validSimType.length === 1 && !selected.simType) {
          handleSelect(pkg.carrier, pkg.carrier_id, "simType", validSimType[0])
        }

        // ---- Scope (Local/Roaming) ----
        const validScope = pkg.scopeList.filter(scope => {
          const key = `${selected.days}-${selected.amount || ""}-${
            selected.typeSim || ""
          }-${selected.simType || ""}-${scope}`
          return Object.keys(pkg.prices).some(k => k.startsWith(key))
        })
        if (validScope.length === 1 && !selected.scope) {
          handleSelect(pkg.carrier, pkg.carrier_id, "scope", validScope[0])
        }
      }
    })
  }, [listPackage, selectedOptions])

  const handleSelect = (carrier, carrierId, type, value) => {
    setSelectedOptions(prev => {
      const current = prev[carrier] || {}
      const updated = { ...current, carrierId, [type]: value }
      const pkg = listPackage.find(d => d.carrier === carrier)

      if (updated.days && updated.amount) {
        const key = `${updated.days}-${updated.amount}-${
          updated.typeSim || ""
        }-${updated.simType || ""}-${updated.scope || ""}`
        updated.price = pkg.prices[key] || pkg.priceRange

        // Lấy ID gói cước dựa trên lựa chọn
        // const packageId = pkg.packageMap[key] ? pkg.packageMap[key][0] : null
        // // 👉 Lấy note từ map
        // updated.note = pkg.notes[key] || ""
        // updated.packageId = packageId // Cập nhật ID gói cước
        const packageItem = pkg.packageMap[key] ? pkg.packageMap[key][0] : null
        if (packageItem) {
          updated.packageId = packageItem.id
          updated.note = packageItem.note || ""
          updated.package_type = packageItem.package_type || null
          updated.mode = packageItem.mode || null
          updated.commission = packageItem.commission || null
          updated.master_price = level != 0 ? packageItem.master_price : null
        }
        console.log("Updated package item:", updated);

        updated.provider = pkg.provider
      }

      return { ...prev, [carrier]: updated }
    })
  }

  const formatPriceRange = prices => {
    if (!Array.isArray(prices) || prices.length === 0) return ""
    const nums = prices.map(Number)
    if (nums.length === 1) {
      return `${nums[0].toLocaleString("en-US")} VNĐ`
    }
    const min = Math.min(...nums)
    const max = Math.max(...nums)
    return ` ${min.toLocaleString("en-US")} VNĐ - ${max.toLocaleString(
      "en-US",
    )} VNĐ`
  }

  const handleBuyNow = (carrier, carrierId, supplierId) => {
    const selected = selectedOptions[carrier]
    if (!selected) return
    const packageItem = {
      carrier: carrier,
      supplier_id: supplierId,
      days: selected.days,
      amount: selected.amount,
      sim_unit_price: selected.price,
      network_id: carrierId,
      package_id: selected.packageId,
      type_sim: selected.typeSim,
      sim_type: selected.simType,
      scope: selected.scope, // Thêm loại SIM vào packageItem
      package_type: selected.package_type, // ✅ lấy từ selected
      mode: selected.mode,
      commission: selected.commission || 0,
      master_price: level != 0 ? selected.master_price : null,
    }
    console.log("====================================")
    console.log("packageItem : ", packageItem)
    console.log("====================================")

    dispatch(
      addToCart({
        packageItem: packageItem,
        typeSim: selected.typeSim,
        simType: selected.simType,
        scope: selected.scope,
      }),
    )
    setOpenCart(true) // Mở giỏ hàng sau khi thêm vào
  }

  return (
    <div className="buy-package-container">
      <div style={{ fontWeight: "bold", color: "#007BFF" }}>
        Tổng số nhà mạng: {listPackage.length}
      </div>
      <CheckPackage setFilter={setFilter} />
      {loading ? (
        <Spin />
      ) : (
        <>
          {" "}
          <Row gutter={[16, 16]}>
            {listPackage.map(pkg => {
              const selected = selectedOptions[pkg.carrier] || {}

              return (
                <Col xs={24} md={8} key={pkg.carrier}>
                  <Card
                    title={<strong>{pkg.carrier}</strong>}
                    bordered
                    style={{
                      borderRadius: "12px",
                      minHeight: "420px",
                    }}
                    hoverable
                  >
                    <p style={{ fontWeight: "bold", color: "#722ed1" }}>
                      {selected.master_price
                        ? `Giá Chung: ${Number(
                            selected.master_price,
                          )?.toLocaleString("en-US")} VNĐ`
                        : (pkg.listsGeneralPrice.length === 1 &&
                            pkg.daysOptions.length === 1 &&
                            `Giá Chung: ${Number(
                              selected.master_price || pkg.listsGeneralPrice[0],
                            )?.toLocaleString("en-US")} VNĐ`) ||
                          (selected.price &&
                            `${
                              selected.price?.toLocaleString("en-US") || "0"
                            } VNĐ`) ||
                          formatPriceRange(pkg.listsGeneralPrice) ||
                          pkg.priceRange}
                    </p>
                    {(selected.commission ||
                      (pkg.listsDiscount.length === 1 &&
                        pkg.daysOptions.length === 1)) && (
                      <p style={{ fontWeight: "bold", color: "#722ed1" }}>
                        Hoa hồng (
                        {Number(
                          selected.commission || pkg.listsDiscount[0],
                        )?.toLocaleString("en-US")}
                        %)
                      </p>
                    )}

                    <p style={{ color: "#888", fontStyle: "italic" }}>
                      {selected.note || "Không có ghi chú"}
                    </p>
                    <p>Khoảng thời gian (ngày)</p>
                    <div>
                      {pkg.daysOptions.map(d => (
                        <Button
                          key={d}
                          size="small"
                          type={selected.days === d ? "primary" : "default"}
                          onClick={() =>
                            handleSelect(pkg.carrier, pkg.carrier_id, "days", d)
                          }
                          style={{ margin: "3px" }}
                        >
                          {d}
                        </Button>
                      ))}
                    </div>
                    <p style={{ marginTop: "12px" }}>Dung lượng</p>
                    <div>
                      {pkg.dataOptions.map(opt => {
                        const key = `${selected.days || ""}-${opt}`
                        const isValid = selected.days
                          ? Object.keys(pkg.prices).some(k => k.startsWith(key)) // 👈 check tồn tại chuỗi con
                          : true

                        return (
                          <Button
                            key={opt}
                            size="small"
                            type={
                              selected.amount === opt ? "primary" : "default"
                            }
                            onClick={() =>
                              handleSelect(
                                pkg.carrier,
                                pkg.carrier_id,
                                "amount",
                                opt,
                              )
                            }
                            style={{ margin: "3px" }}
                            disabled={!isValid}
                          >
                            {opt}
                          </Button>
                        )
                      })}
                    </div>

                    <p style={{ marginTop: "12px" }}>Loại SIM</p>
                    <div>
                      {pkg.typeSimList
                        .filter(type => type === "esim" || type === "usim")
                        .map(type => {
                          // Ghép key dựa vào selected trước đó + typeSim
                          const key = `${selected.days}-${selected.amount}-${type}`
                          const isValid = selected.days
                            ? Object.keys(pkg.prices).some(k =>
                                k.startsWith(key),
                              ) // 👈 check tồn tại chuỗi con
                            : true

                          return (
                            <Button
                              key={type}
                              size="small"
                              type={
                                selected.typeSim === type
                                  ? "primary"
                                  : "default"
                              }
                              onClick={() =>
                                handleSelect(
                                  pkg.carrier,
                                  pkg.carrier_id,
                                  "typeSim",
                                  type,
                                )
                              }
                              style={{ margin: "3px" }}
                              disabled={!isValid} // 👈 khóa nếu không hợp lệ
                            >
                              {type === "usim" ? "Sim vật lý" : "E-SIM"}
                            </Button>
                          )
                        })}
                    </div>

                    <p style={{ marginTop: "12px" }}>Loại hình SIM</p>
                    <div>
                      {pkg.simTypeList
                        .filter(type => type === "1" || type === "2")
                        .map(type => {
                          // Ghép key dựa vào selected trước đó + simType
                          const key = `${selected.days}-${selected.amount}-${selected.typeSim}-${type}`
                          const isValid = selected.days
                            ? Object.keys(pkg.prices).some(k =>
                                k.startsWith(key),
                              ) // 👈 check tồn tại chuỗi con
                            : true

                          return (
                            <Button
                              key={type}
                              size="small"
                              type={
                                selected.simType === type
                                  ? "primary"
                                  : "default"
                              }
                              onClick={() =>
                                handleSelect(
                                  pkg.carrier,
                                  pkg.carrier_id,
                                  "simType",
                                  type,
                                )
                              }
                              style={{ margin: "3px" }}
                              disabled={!isValid} // 👈 khóa nếu không hợp lệ
                            >
                              {type === "1" ? "IoT" : "Travel"}
                            </Button>
                          )
                        })}
                    </div>
                    <p style={{ marginTop: "12px" }}>Local/Roaming</p>
                    <div>
                      {pkg.scopeList
                        .filter(scope => scope === "1" || scope === "2")
                        .map(scope => {
                          // Ghép key dựa vào selected trước đó + simType
                          const key = `${selected.days}-${selected.amount}-${selected.typeSim}-${selected.simType}-${scope}`
                          const isValid = selected.days
                            ? Object.keys(pkg.prices).some(k =>
                                k.startsWith(key),
                              ) // 👈 check tồn tại chuỗi con
                            : true

                          return (
                            <Button
                              key={scope}
                              size="small"
                              type={
                                selected.scope === scope ? "primary" : "default"
                              }
                              onClick={() =>
                                handleSelect(
                                  pkg.carrier,
                                  pkg.carrier_id,
                                  "scope",
                                  scope,
                                )
                              }
                              style={{ margin: "3px" }}
                              disabled={!isValid} // 👈 khóa nếu không hợp lệ
                            >
                              {scope === "1" ? "Local" : "Roaming"}
                            </Button>
                          )
                        })}
                    </div>

                    <div
                      style={{
                        marginTop: "16px",
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                      }}
                    >
                      {/* <Button disabled>Xem chi tiết</Button> */}
                      <Button
                        type="primary"
                        size="large"
                        icon={<ShoppingCartOutlined />}
                        className="custom-buy-btn"
                        disabled={
                          !selected.days ||
                          !selected.amount ||
                          !selected.typeSim ||
                          !selected.simType ||
                          !selected.scope ||
                          !(
                            pkg.prices[
                              `${selected.days}-${selected.amount}-${selected.typeSim}-${selected.simType}-${selected.scope}`
                            ] || selected.master_price
                          )
                        }
                        onClick={() =>
                          handleBuyNow(
                            pkg.carrier,
                            pkg.carrier_id,
                            pkg.supplier,
                          )
                        }
                        onMouseEnter={e => {
                          e.currentTarget.style.transform = "scale(1.05)"
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.transform = "scale(1)"
                        }}
                      >
                        Mua ngay
                      </Button>
                    </div>
                  </Card>
                </Col>
              )
            })}
          </Row>
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Pagination
              style={{ display: "flex", justifyContent: "flex-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={total}
              onChange={(page, size) => {
                setCurrentPage(page)
                setPageSize(size)
              }}
              showSizeChanger
              pageSizeOptions={["6", "12", "18", "24"]}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default BuyPackageAnonymous
